<template>
  <div
    v-if="showAdminModal"
    class="modal w-full h-screen p-8 fixed flex justify-center items-center"
  >
    <div class="overlay fixed  w-full min-h-screen"></div>
    <div
      class="modal-content h-screen lg:h-auto m-8 overflow-y-scroll w-full relative"
    >
      <!-- close button -->
      <div
        @click="close"
        class="close absolute flex flex-row flex-wrap justify-center items-center text-white cursor-pointer"
      >
        <img :src="require('../../assets/close.png')" alt="" />
      </div>

      <div class="bg-white px-8 py-4 ">
        <div class="modal-title main-tenant-color font-semibold mb-2">
          New Course
        </div>
        <div class="flex flex-row flex-wrap">
          <div class="flex flex-col flex-wrap flex-grow items-start mr-12">
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Title:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.title"
                  :errorMessage="errors.title"
                  :error="errors.title"
                  placeholder="Title of Course"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Description:</div>
              <div class="flex-grow ml-auto">
                <ltextarea
                  v-model="form.description"
                  :errorMessage="errors.description"
                  :error="errors.description"
                  placeholder="Course Description"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Overview Image URL:</div>
              <div class="flex-grow ml-auto">
                <vue-dropzone
                  @vdropzone-drag-drop="uploadFile"
                  @vdropzone-file-added="uploader"
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                ></vue-dropzone>
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Duration:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  v-model="form.duration"
                  :errorMessage="errors.duration"
                  :error="errors.duration"
                  placeholder="e.g 20 days"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Course Instructor:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  v-model="form.course_instructor"
                  :errorMessage="errors.course_instructor"
                  :error="errors.course_instructor"
                  placeholder="e.g Jane Doe"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Select Program:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.type"
                  v-model="id"
                  :items="getPrograms"
                  :errorMessage="errors.type"
                  placeholder="Select Program"
                />
              </div>
            </div>
            <div
              v-if="showAssets"
              class="flex flex-row items-center form-row mb-8"
            >
              <div class="modal-field font-semibold">Overview Video:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  selected
                  :error="errors.course_video"
                  v-model="form.course_video"
                  :errorMessage="errors.course_video"
                  :items="getResources"
                  placeholder="Select Overview Video"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col flex-wrap flex-grow items-start">
            <!-- <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Skills:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.skills_to_be_acquired"
                  :error="errors.skills_to_be_acquired"
                  :errorMessage="errors.skills_to_be_acquired"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div> -->
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Resources Required:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.resources_required"
                  :error="errors.resources_required"
                  :errorMessage="errors.resources_required"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Payment Type:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.payment_type"
                  v-model="form.payment_type"
                  :errorMessage="errors.payment_type"
                  :items="payment"
                  placeholder="Select Payment Type"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Currency:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.currency"
                  v-model="form.currency"
                  :items="currency"
                  :errorMessage="errors.currency"
                  placeholder="Select Currency"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Price:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.price"
                  :error="errors.price"
                  :errorMessage="errors.currency"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Pacing:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.pace"
                  v-model="form.pace"
                  :items="pacing"
                  :errorMessage="errors.currency"
                  placeholder="Select Course Pace"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Publish State:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.course_state"
                  v-model="form.course_state"
                  :errorMessage="errors.course_state"
                  :items="publish"
                  placeholder="Select Publish State"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-wrap justify-center items-center">
          <div class="mb-2">
            <lms-button @click="handleFormSubmit">Add Course</lms-button>
          </div>
          <!-- <div class="mb-12 cursor-pointer" style="color:#102767 ">
						Import from csv 
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      id: "",
      showAssets: false,
      payment: [
        {
          text: "Free",
          value: "free",
        },
        {
          text: "Paid",
          value: "paid",
        },
        {
          text: "Coupon",
          value: "coupon",
        },
      ],
      currency: [
        {
          text: "Naira",
          value: "NGN",
        },
        {
          text: "Dollars",
          value: "DOL",
        },
      ],
      pacing: [
        {
          text: "Self-Paced",
          value: "self",
        },
        {
          text: "Fixed Timed",
          value: "fixed",
        },
      ],
      publish: [
        {
          text: "Published",
          value: "published",
        },
        {
          text: "Draft",
          value: "draft",
        },
      ],
      errors: [],
      form: {},
    };
  },
  model: {
    prop: "showAdminModal",
    event: "closeAdminModal",
  },
  props: {
    showAdminModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getTenantPrograms", "getResources"]),
    getPrograms() {
      let programs = this.getTenantPrograms;
      let sortedPrograms = [];
      for (let i = 0; i < programs.length; i++) {
        let temp = {
          text: programs[i].title,
          value: programs[i].id,
        };
        //console.log(temp);
        sortedPrograms = sortedPrograms.concat(temp);
      }
      //console.log(sortedPrograms);
      return sortedPrograms;
    },
  },
  mounted() {
    this.fetchTenantPrograms();
    this.loadResource();
  },
  methods: {
    async loadResource(e) {
      let res = await this.loadUserAssets();
      // //console.log("jjjjjjj");
      this.showAssets = true;
    },
    async uploader(file) {
      let imageUrl = await this.uploadFile(file);
      this.form.course_image = imageUrl;
    },
    ...mapActions([
      "fetchTenantPrograms",
      "tenantCreateCourse",
      "loadUserAssets",
    ]),
    async handleFormSubmit() {
      this.errors = [];
      let res = await this.tenantCreateCourse({
        id: this.id,
        course: this.form,
      });

      if (res == true || res.status == 200 || res.status == 201) {
        this.$emit("notify", {
          type: "success",
          message: "Course created successfully",
        });

        this.close();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
        }
      }
    },
    close() {
      this.$emit("closeAdminModal", false);
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-tenant);
    }

    .modal-field {
      color: color(lms-tenant);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: 0px;
      z-index: 2;
      right: 0px;
    }
    z-index: 1;
  }
}
</style>
